(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trimita-winter-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('trimita-hero-carousel')) {
  customElements.define('trimita-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = Array.from(this.querySelectorAll('.trimita-hero-carousel__slide'));
      if (this.slides.length < 2) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal });
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.desktop = matchMedia('(min-width: 900px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userStopped = false;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.visible = false;
      this.toggle = this.querySelector('[data-toggle]');
      this.position = this.querySelector('[data-position]');
      this.status = this.querySelector('[data-status]');
      const viewport = this.querySelector('.trimita-hero-carousel__viewport');
      const stop = event => {
        if (event.target.closest('[data-toggle]')) return;
        this.userStopped = true;
        this.sync();
      };
      listen(this, 'pointerdown', stop);
      listen(this, 'keydown', event => {
        stop(event);
        if (!event.target.closest('.trimita-hero-carousel__controls') || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1, true);
        }
      });
      listen(this.querySelector('[data-previous]'), 'click', () => this.move(-1, true));
      listen(this.querySelector('[data-next]'), 'click', () => this.move(1, true));
      listen(this.toggle, 'click', () => {
        this.userStopped = !this.userStopped;
        if (!this.userStopped) this.focused = false;
        this.sync();
      });
      listen(this, 'pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.sync();
      });
      listen(this, 'pointerleave', () => {
        this.hovered = false;
        this.sync();
      });
      listen(this, 'focusin', () => {
        this.focused = true;
        this.sync();
      });
      listen(this, 'focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.sync();
      });
      listen(document, 'visibilitychange', () => this.sync());
      listen(this.desktop, 'change', () => this.sync());
      listen(this.reduced, 'change', () => this.sync());
      listen(viewport, 'pointerdown', event => {
        if (this.desktop.matches || !event.isPrimary || event.pointerType === 'mouse') return;
        this.swipe = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, { passive: true });
      listen(viewport, 'pointerup', event => {
        if (!this.swipe || event.pointerId !== this.swipe.id) return;
        const dx = event.clientX - this.swipe.x;
        const dy = event.clientY - this.swipe.y;
        this.swipe = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          this.suppressClickUntil = Date.now() + 500;
          this.move(dx < 0 ? 1 : -1, true);
        }
      }, { passive: true });
      listen(viewport, 'pointercancel', () => { this.swipe = null; }, { passive: true });
      listen(viewport, 'click', event => {
        if (Date.now() >= (this.suppressClickUntil || 0)) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClickUntil = 0;
      }, { capture: true });
      listen(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index < 0) return;
        this.userStopped = true;
        this.show(index, true);
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.sync();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.setAttribute('data-enhanced', '');
      this.sync();
    }
    move(direction, manual = false) {
      if (manual) this.userStopped = true;
      this.show((this.index + direction + this.slides.length) % this.slides.length, manual);
    }
    show(index, announce = false) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.position.textContent = `${index + 1} / ${this.slides.length}`;
      if (announce) this.status.textContent = this.slides[index].getAttribute('aria-label');
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.toggle.setAttribute('aria-label', this.userStopped ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.querySelector('[data-toggle-icon]').textContent = this.userStopped ? '▶' : 'Ⅱ';
      if (this.desktop.matches && !this.reduced.matches && !this.userStopped && !this.hovered && !this.focused && this.visible && !document.hidden) {
        this.timer = setTimeout(() => this.move(1), 7000);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.swipe = null;
      this.removeAttribute('data-enhanced');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
